/**
 * Whether an item can be ordered given its visible stock and the portal-wide
 * backorder switch (lib/settings/backorders.ts). Pure, so client components
 * can use the labels without pulling in the settings read.
 */
export type StockAvailability = 'in_stock' | 'backorder' | 'out_of_stock';

/** Stock 0 is orderable as a backorder only while the switch is on. */
export function stockAvailability(totalStock: number, allowBackorders: boolean): StockAvailability {
  if (totalStock > 0) return 'in_stock';
  return allowBackorders ? 'backorder' : 'out_of_stock';
}

export const BACKORDER_LABEL = 'Backorder';
export const ADD_AS_BACKORDER_LABEL = 'Add as backorder';
export const OUT_OF_STOCK_LABEL = 'Out of stock';
